export default __webpack_public_path__ + "static/media/HW_13.f3da302a.png";